/*
 File: content-mrk-ad.js
 Author: D McCleod
 Created: 11/26/2018
 Description: insert a content marketing add 1122 into the slide content, based on the url query string "ecd=conmkt"
 */

import { getSlideElement, getScreenOrientation } from './slider-events';
import { DeferHandler } from './deferred';
import * as hashManager from './hash-manager';
import * as config from './config';

'use strict';
const contentMarketing = {
    queryString: 'ecd=conmkt',
    adClass: 'AdUnit',
    adParentClass: 'ad-parent',
    allSlidesClass: 'all_slides_link',
    contentAdClass: 'content-ad',
    imageCntClass: 'crs-slide_figure_img',
    initialClass: 'empty-container',
    lastClass: 'crs-slide--last',
    noImgClass: 'crs-slide--noimg',
    parentClass: 'crs-slide_figure',
    relatedClass: 'related-slides',
    rdMrButtonClass: 'read-more',
    slideContentClass: 'has-content-ad',
    slideCopyClass: 'crs-slide__copy',
    slideRdClass: 'rdmore',
    slideRdClass_active: 'rdmore-clicked',
    wrapperClass: 'ad-wrapper',
    initialized: null,
    prevSlide: [],
    initContent: (slick) => {
        const CM = contentMarketing;
        CM.deferHandler = new DeferHandler();
        CM.remove1005Container();
        CM.slick = slick;
        CM.slickList = CM.slick.$list;
        CM.currentSlide = null;
        CM.prevIndex = null;
        CM.currentIndex = null;
        CM.setListeners();
        CM.triggerOnInit();
        return CM.initialized = true;
    },
    setListeners: () => {
        $(window)
            .on('hashchange', (e, data) => {
                // a 1 must be subtracted from the index to match the pagination and hash, since the index starts at 0.
                // if user changes hash to navigate and the container is empty, insert ad
                const currSlide = contentMarketing.currentSlide || getSlideElement(hashManager.getHash() -1),
                adCnt = currSlide.find(`.${contentMarketing.contentAdClass}`);

                if(adCnt.hasClass(contentMarketing.initialClass)) contentMarketing.insertContentAd(adCnt, currSlide);
                // toggle the state of the previous ad IF the read more button was clicked!
                contentMarketing.resetAdState();
            })
            .on('beforeslidechange', (e, data) => { // data: index, prev, store the previously view slide info
                contentMarketing.prevSlide.push(data);
                contentMarketing.currentSlide = data.next;
                contentMarketing.prevIndex = data.index;
            })
            .on('afterslidechange', (e, data) => { // data.container, data.id
                contentMarketing.insertContentAd(data.container, data.slide);
                contentMarketing.resetAdState();
                contentMarketing.prevIndex = contentMarketing.currentIndex = data.index;
                // update currentSlide on initial load, since this event is triggered first
                if(contentMarketing.currentSlide === null) contentMarketing.currentSlide = data.slide;
                // reset slide container height for collapsed read more, wait until scrolling is finished by placing in deffered object cue
                if(slideShow.isScrolling) {
                    const boundReset = contentMarketing.callResetSlideHeight.bind(contentMarketing, data);
                    contentMarketing.deferHandler.addToCue(boundReset);
                } else {
                    contentMarketing.callResetSlideHeight(data);
                }
            })
            .on('orientationchange', () => {
                setTimeout(() => {
                    slideShow.orientation = getScreenOrientation();
                    contentMarketing.setAdWidth(contentMarketing.currentSlide);
                }, 300);
            })
            .on('scroll:ended', () => {
                if(contentMarketing.deferHandler.cue.length > 0) contentMarketing.deferHandler.deferred.resolve();
            });

        $(document).on('click', '.ad-wrapper .read-more', (e) => {
            const slide = $(e.target).parents(`.${contentMarketing.slideRdClass}`);
            slide.removeClass(contentMarketing.slideRdClass).addClass(contentMarketing.slideRdClass_active);
            $(window).trigger('' +
                '' +
                'resetSlideHeight', {
                slide: slide,
                list: contentMarketing.slickList
            });
        });
    },
    callResetSlideHeight: (data) => {
        let ad = data.slide.find(`.${contentMarketing.adClass}`)[0];
        if(!contentMarketing.isFirstOrLast(data.slide[0]) && ad !== undefined) {
            $(window).trigger('resetSlideHeight', {
                slide: data.slide,
                list: contentMarketing.slickList,
                adHeight: ad.getBoundingClientRect().bottom,
                collapsed: true
            });
        }
    },
    triggerOnInit: () => {
        const initialSlide = getSlideElement(slideShow.initialSlide);
        const slideIndex = initialSlide.data('slick-index');
        const isCollapsed = slideIndex > 0 && slideIndex < (slideShow.slideCount - 1);
        console.log('triggerOnInit  content ad', initialSlide.find(`.${contentMarketing.contentAdClass}`)[0]);
        $(window)
            .trigger('afterslidechange', {
                container: initialSlide.find(`.${contentMarketing.contentAdClass}`),
                slide: initialSlide
            })
            .trigger('resetSlideHeight', {
                slide: initialSlide,
                list: contentMarketing.slick.$list,
                adHeight: initialSlide.find(`.${contentMarketing.adClass}`)[0].getBoundingClientRect().bottom,
                collapsed: isCollapsed
            });
    },
    checkQueryString: (cm) => {
        return window.location.search.indexOf(cm.queryString) !== -1;
    },
    remove1005Container: () => {
        window.ads2_ignore['1005'] = 'true';
        $('.mobile_adlabelleft').remove();
    },
    buildAdContainer: (slickCnt) => {
        const CM = contentMarketing;
        const allSlides = slickCnt[0].querySelectorAll(config.configObj.slide);
        allSlides.forEach( (slide, i, allSlides) => {
            $(slide).addClass(() => {
                return i === 0 ? config.wrapperClassNames[0] : (CM.isFirstOrLast(slide) ? '' : CM.slideRdClass);
            });

            // define different insertion point by neighboring element, depending on if user is currently on last slide
            const initClass = `${CM.contentAdClass} ${CM.initialClass}`;
            const neighborEle = CM.getNeighborEle(CM, $(slide));
            // wrap ad inside a container to manage height and read more layout
            const adWrapper = $(document.createElement('div'))
                .attr('id', `ad-wrapper-${i+1}`)
                .addClass(CM.wrapperClass)
                .insertAfter(neighborEle)
                .append(
                    $(document.createElement('div')) // ==> google ad will be inserted here
                    .attr('id',`ads-pos-1122_${i+1}`)
                    .addClass(initClass)
                );
            // only insert read more if not first or last slide, set width to parent width
            if(!CM.isFirstOrLast(slide)) CM.insertReadMore(adWrapper.width(neighborEle.parent(`.${CM.adParentClass}`).width()) );
            return adWrapper;
        });

    },
    getNeighborEle: (CM, slide) => {
        // return neighboring element for insertion point of content ad
        let neighbor;
        if(slide.hasClass(CM.lastClass)) {
            neighbor = slide.find(`.${CM.allSlidesClass}`);
        } else if(slide.hasClass(CM.noImgClass)) {
            neighbor = slide.find(`.${CM.relatedClass}`);
        } else {
            neighbor = slide.find(`.${CM.slideCopyClass}`).addClass(CM.slideContentClass);
            neighbor.parent().addClass(CM.adParentClass);
            // add a class to the parent container <figcaption>
        }
        return neighbor;
    },
    isFirstOrLast: (slide) => {
        // return boolean if first, last or related slide
        const id = parseInt(slide.dataset.slickIndex);
        const last = slide.classList.value.split(' ').find((val) => {
            return [contentMarketing.noImgClass, contentMarketing.lastClass].includes(val);
        });
        return last && id !== 0;
    },
    insertReadMore: (cnt) => {
        const readMore = document.createElement('span');
        readMore.textContent = 'Read more';
        readMore.classList.add(contentMarketing.rdMrButtonClass);
        cnt.prepend(readMore);
        // click handler set in setListeners()
        return readMore;
    },
    insertContentAd: (container, slide) => {
        const CM = contentMarketing;
        // do not define on a previously inserted container
        if(container[0] === undefined) return;
        const adId = container[0].id;
        if(!adId) {
            console.error('! ~~~~~> id not defined', container);
            return;
        }
        if(!container.hasClass(CM.initialClass)) {
            webmd.ads2.refresh({id: adId});
        } else {
            container
                .removeClass(CM.initialClass)
                .addClass(CM.adClass);
            webmd.ads2.defineAd({
                id: adId,
                pos: 1122,
                collapseAfter: true,
                display: false
            });
            webmd.ads2.refresh({ id: adId });
        }

        return container[0].id;
    },
    resetAdState: () => {
        // if prevSlide array is empty / is from slideshow init
        // collapses the read more with content ad on the slide previously viewed
        if(contentMarketing.prevSlide.length > 0) {
            const prevSlide = contentMarketing.prevSlide.pop().prev;
            if(!contentMarketing.isFirstOrLast(prevSlide[0]) && prevSlide.hasClass(contentMarketing.slideRdClass_active)) {
                prevSlide.removeClass(contentMarketing.slideRdClass_active).addClass(contentMarketing.slideRdClass);
            }
        }
    },
    setAdWidth: (slide) => {
      const newWidth =  contentMarketing.isFirstOrLast(slide[0]) ? 'initial' : slide.find(`.${contentMarketing.adParentClass}`).width();
      // reset the width of all ad containers based on the parent width
      $(`.${contentMarketing.wrapperClass}`).each((i, ad) => {
          $(ad).width(newWidth);
      });
      return newWidth;
    }
};

export { contentMarketing };
